<template>
  <div id="Jan2024" class="202401 relative">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <!-- <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202307/menu/right.png" class="object-contain w-full">
      </a> -->
      <a class="block px-3">
        <img src="~@/assets/images/202401/menu/menu-off_01.png" class="object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan1')">
        <img src="~@/assets/images/202401/menu/menu-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202401/menu/menu-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan2')">
        <img src="~@/assets/images/202401/menu/menu-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202401/menu/menu-on_03.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#plan3')">
        <img src="~@/assets/images/202401/menu/menu-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202401/menu/menu-on_04.png" class="on object-contain">
      </a>
    </div>
    <div class="banner w-full pt-3 md:pt-6">
      <div class="flex justify-center md:items-end px-2 md:px-6 xl:px-0">
        <div class="-mr-2 md:mr-0">
          <img src="~@/assets/images/202401/L-B.png" class="object-contain hidden md:block" data-aos="fade-right" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
          <img src="~@/assets/images/202401/lantern.png" class="object-contain md:hidden">
        </div>
        <div class="pt-6 md:pt-0 md:pb-4"><img src="~@/assets/images/202401/master-vis.png" class="object-contain block"></div>
        <div class="-ml-2 md:ml-0">
          <img src="~@/assets/images/202401/R-G.png" class="object-contain hidden md:block" data-aos="fade-left" data-aos-easing="ease" data-aos-once="true" data-aos-offset="100">
          <img src="~@/assets/images/202401/lantern.png" class="object-contain md:hidden">
        </div>
      </div>
      <div class="flex justify-center items-end md:hidden px-12 -mt-6">
        <div>
          <img src="~@/assets/images/202401/L-boy.png" class="object-contain">
        </div>
        <div>
          <img src="~@/assets/images/202401/R-girl.png" class="object-contain">
        </div>
      </div>
      <div class="sales md:flex justify-center mb-6 px-2 md:px-0">
        <div><img src="~@/assets/images/202401/L-500.png" class="object-contain block"></div>
        <div><img src="~@/assets/images/202401/R-8888.png" class="object-contain block"></div>
      </div>
      <div class="plans flex justify-center">
        <div><img src="~@/assets/images/202401/plan0.png" class="object-contain block"></div>
      </div>
    </div>

    <section class="main mb-12 container mx-auto">
      <div class="flex justify-center mb-12">
        <div class="hidden md:block"><img src="~@/assets/images/202401/plan1.png" class="object-contain block"></div>
        <div class="md:hidden"><img src="~@/assets/images/202401/mobile/m-plan.png" class="object-contain block"></div>
      </div>
      <div id="plan1" class="plan1 mb-12 px-2">
        <div class="flex justify-center">
          <div>
            <img src="~@/assets/images/202401/plan-1-BG.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-1-BG.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="plan1_inner flex flex-col justify-center items-center bg-white p-6 md:p-12 useless_border">
          <div class="mb-4"><img src="~@/assets/images/202401/plan-1-1.png" class="object-contain block"></div>
          <div class="mb-4"><img src="~@/assets/images/202401/plan-1-2.png" class="object-contain block"></div>
          <div class="mb-6">
            <img src="~@/assets/images/202401/plan-1-3.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-1-3.png" class="object-contain md:hidden">
          </div>
          <div class="mb-4">
            <img src="~@/assets/images/202401/plan-1-4.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-1-4.png" class="object-contain md:hidden">
          </div>
          <a class="py-5" href="https://store.liveabc.com/products/book/sale?tag=324" target="_blank">
            <img src="~@/assets/images/202401/plan-1-order-bt.png" class="object-contain block">
          </a>
        </div>
      </div>
      <div id="plan2" class="plan2 mb-12 px-2">
        <div class="flex justify-center mb-4">
          <div>
            <img src="~@/assets/images/202401/plan-2-BG.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-2-BG.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="plan1_inner flex flex-col justify-center items-center">
          <a class="mb-4" href="https://store.liveabc.com/products/book/sale?tag=325" target="_blank">
            <img src="~@/assets/images/202401/plan-2-1.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-2-1.png" class="object-contain md:hidden">
          </a>
          <div class="flex flex-wrap">
            <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 md:w-1/4 p-2" v-for="(item, index) in bookData" :key="index">
              <img :src="item.img_url" class="object-contain block">
            </router-link>
          </div>
        </div>
      </div>
      <div id="plan3" class="plan3 px-2">
        <div class="flex justify-center">
          <div>
            <img src="~@/assets/images/202401/plan-3-BG.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-3-BG.png" class="object-contain md:hidden">
          </div>
        </div>
        <div class="plan1_inner flex flex-col justify-center items-center bg-white p-6 md:p-12 useless_border">
          <div class="mb-4"><img src="~@/assets/images/202401/plan-3-1.png" class="object-contain block"></div>
          <div class="mb-4">
            <img src="~@/assets/images/202401/plan-3-2.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-3-2.png" class="object-contain md:hidden">
          </div>
          <div class="flex">
            <a class="py-5" href="https://liveabc-dokodemo.azurewebsites.net/scorm/post/JPN1906L20/" target="_blank">
              <img src="~@/assets/images/202401/plan-3-free-bt.png" class="object-contain block">
            </a>
            <a class="py-5" href="https://store.liveabc.com/products/book/sale?tag=326" target="_blank">
              <img src="~@/assets/images/202401/plan-1-order-bt.png" class="object-contain block">
            </a>
          </div>
          <div class="mb-6"><img src="~@/assets/images/202401/plan-3-3.png" class="object-contain block"></div>
          <div class="mb-4">
            <img src="~@/assets/images/202401/plan-3-4.png" class="object-contain hidden md:block">
            <img src="~@/assets/images/202401/mobile/m-plan-3-4.png" class="object-contain md:hidden">
          </div>
          <div class="mb-4"><img src="~@/assets/images/202401/plan-3-5.png" class="object-contain block"></div>
          <div class="mb-4"><img src="~@/assets/images/202401/plan-3-6.png" class="object-contain block"></div>

        </div>
      </div>
    </section>

    <section class="footer xl:py-16">
      <div class="container px-4 text-center">
        <h6 class="text-xl mb-4 font-semibold">注意事項</h6>

        <p class="text-lg leading-loose">活動時間2024.1.1~2.15於pveABC官方網站消費單筆訂單滿2,000元，即可參加抽獎活動，訂單成立並完成付款後即符合抽獎資格。</p>
        <p class="text-lg leading-loose">將於2024.3.20抽出2名得主，公告於pveABC官方網站及官方臉書粉絲團。活動期間產生之訂單取消、退貨、交易失敗等條件，</p>
        <p class="text-lg leading-loose">將失去參與本活動之資格，不予另行通知。活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>

      </div>
      <div class="w-full mt-4">
        <img src="~@/assets/images/202401/mobile/m-down-bar.png" class="w-full object-contain xl:hidden">
      </div>
    </section>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: '202401',
  metaInfo () {
    return {
      title: '買點讀筆送12期雜誌✨LiveABC新春送好禮抽現金',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: true,
      bookData: [
        { id: 7694, img_url: require('@/assets/images/202401/plan-2-b1.png') },
        { id: 7549, img_url: require('@/assets/images/202401/plan-2-b2.png') },
        { id: 7494, img_url: require('@/assets/images/202401/plan-2-b3.png') },
        { id: 8286, img_url: require('@/assets/images/202401/plan-2-b4.png') },
        { id: 8134, img_url: require('@/assets/images/202401/plan-2-b5.png') },
        { id: 9108, img_url: require('@/assets/images/202401/plan-2-b6.png') },
        { id: 8588, img_url: require('@/assets/images/202401/plan-2-b7.png') },
        { id: 8742, img_url: require('@/assets/images/202401/plan-2-b8.png') },
        { id: 9237, img_url: require('@/assets/images/202401/plan-2-b9.png') },
        { id: 7456, img_url: require('@/assets/images/202401/plan-2-b10.png') },
        { id: 8158, img_url: require('@/assets/images/202401/plan-2-b11.png') },
        { id: 8150, img_url: require('@/assets/images/202401/plan-2-b12.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#Jan2024 {
  background-color: #fbe1d5;
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }

  .banner {
    background-image: url('~@/assets/images/202401/up-bar.png'), url('~@/assets/images/202401/background.png');
    background-repeat: no-repeat;
    background-size: contain, cover;

    background-position: top center, center;
    @media (max-width: 767px) {
      background-image: url('~@/assets/images/202401/mobile/m-up-bar.png'), url('~@/assets/images/202401/mobile/background.png');
    }
  }
  .main {
    .useless_border {
      position: relative;
      &:before {
        position: absolute;
        content: "";
        height: 16px;
        width: 75%;
        top: -6px;
        background: #860000;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 8px;
        @media (max-width: 768px) {
          width: 100%;
          height: 6.4px;
        }
      }
      &:after {
        position: absolute;
        content: "";
        height: 16px;
        width: 75%;
        bottom: -6px;
        background: #860000;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 8px;
        @media (max-width: 768px) {
          display: none;
        }
      }
    }
    .plan1 {
      .plan1_inner {
        border-radius: 75px;
        border: 6px solid #CC4915;
        box-shadow: 20px 20px 0px 0px #CC491540;
        @media (max-width: 768px) {
          border: 3px solid #CC4915;
          border-top-left-radius: 0px 0px;
          border-top-right-radius: 0px 0px;
          border-bottom-right-radius: 50px 50px;
          border-bottom-right-radius: 50px 50px;
          box-shadow: 10px 10px 0px 0px #CC491540;
        }
      }
    }
    .plan3 {
      .plan1_inner {
        border-radius: 75px;
        border: 6px solid #CC4915;
        box-shadow: 20px 20px 0px 0px #CC491540;
        @media (max-width: 768px) {
          border: 3px solid #CC4915;
          border-top-left-radius: 0px 0px;
          border-top-right-radius: 0px 0px;
          border-bottom-right-radius: 50px 50px;
          border-bottom-right-radius: 50px 50px;
          box-shadow: 10px 10px 0px 0px #CC491540;
        }
      }
    }
  }

  .footer {
    // min-height: 280px;
    background-image: url('~@/assets/images/202401/down-bar.png');
    background-repeat: repeat-x;
    background-size: contain;

    background-position: bottom center;
    @media (max-width: 1439px) {
      background-image: none;
    }
  }
}
</style>
